import { render, staticRenderFns } from "./AppMetricBlockBasic.vue?vue&type=template&id=261bff60&"
import script from "./AppMetricBlockBasic.vue?vue&type=script&lang=js&"
export * from "./AppMetricBlockBasic.vue?vue&type=script&lang=js&"
import style0 from "./AppMetricBlockBasic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports